import { render, staticRenderFns } from "./BookingMessagesList.vue?vue&type=template&id=6527154a"
import script from "./BookingMessagesList.vue?vue&type=script&lang=js"
export * from "./BookingMessagesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports